// import { getToken } from "../../utils/token";

const URL = process.env.REACT_APP_API_SERVER;

export const getMeData = async (token: string | null) => {
  try {
    const rawResponse = await fetch(`${URL}/api/users/me`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const getCounties = async () => {
  const response = await fetch(`${URL}/api/counties`);
  const jsonData = await response.json();
  return jsonData;
};

export const getMerchants = async () => {
  console.log(process.env);

  const response = await fetch(`${URL}/api/merchants`);
  const jsonData = await response.json();
  return jsonData;
};

export const getMerchantsByID = async (
  id: number,
  type: string = "merchants"
) => {
  const response = await fetch(`${URL}/api/${type}/${id}`);
  const jsonData = await response.json();
  return jsonData;
};

export const getProductsByMerchantId = async (id: number) => {
  const response = await fetch(`${URL}/api/merchants/${id}/products`);
  const jsonData = await response.json();
  return jsonData;
};

export const getUser = async (id: number, token: number) => {
  try {
    const rawResponse = await fetch(`${URL}/api/users/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const getServices = async () => {
  try {
    const rawResponse = await fetch(`${URL}/api/services`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const getTypes = async () => {
  try {
    const rawResponse = await fetch(`${URL}/api/placeTypes`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const getAvailabilities = async (id: string | number) => {
  const token = localStorage.getItem("access_token");
  try {
    const rawResponse = await fetch(
      `${URL}/api/merchants/${id}/availabilities`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const getCart = async () => {
  try {
    const token = localStorage.getItem("access_token");
    const rawResponse = await fetch(`${URL}/api/cart`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    console.log(err);
  }
};

export const getMyBookings = async (page: number, pageSize: number) => {
  try {
    const token = localStorage.getItem("access_token");
    // Calculate skip and take from page and pageSize
    const skip = (page - 1) * pageSize;
    const take = pageSize;
    
    const url = `${URL}/api/me/bookings?skip=${skip}&take=${take}`;
    
    const rawResponse = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    console.log(err);
  }
};

export const getMyReviews = async () => {
  try {
    const token = localStorage.getItem("access_token");
    const rawResponse = await fetch(`${URL}/api/users/me/reviews`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    console.log(err);
  }
};
